module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/1-33750750eb26207e02c2dd7efb3e4b0f.jpg";